// extracted by mini-css-extract-plugin
export var caretAnchor = "_ve-0";
export var dropdownContent = "_ve-1";